// eslint-disable-next-line @typescript-eslint/no-redeclare
export const authGlobals = {};
//# sourceMappingURL=authGlobals.js.map